// extracted by mini-css-extract-plugin
export default {"linkLotsPlatePreview":"linkLotsPlatePreview-_RyNV","plates":"plates-Iaa0N","gridItem":"gridItem-WM1RN","plateName":"plateName-VgvEO"};